import React, { useMemo } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import DisplayTransition from '../../../../../../desktop/components/transitions/display-transition'
import { BlackMask } from '../../../../../../components/mask'
import { BigButton } from '../../../../../../components/button'
import { FormattedMessage } from 'react-intl'
import CountDown from '../../../../../../components/count-down'

export const StayAlert = props => {
    useStyles(classes)

    const { serverTime, retentionPromptWin, onDeepLink, onLeave, sensors, onClose } = props

    const { description, expirationDate, imageURL, type, buttons } = retentionPromptWin

    const clickHandle = (button, index) => {
        const { deepLink } = button

        if (!deepLink && index === 1) {
            onLeave(sensors)
        } else if (!deepLink) {
            onClose(sensors)
        } else {
            onDeepLink(deepLink, sensors)
        }
    }

    return <div className={classes.StayAlert}>
        <div className={classes.Content}>
            <span dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        <div className={classes.Image}>
            <img src={imageURL} />
        </div>
        {
            expirationDate > serverTime && <div className={classes.Timing}>
                <span className={classes.Label}>
                    <FormattedMessage id="ends_in" defaultMessage="Ends In" />
                </span>
                <span className={classes.Value}>
                    {' '}<CountDown showHour showDay offset={expirationDate - serverTime} />
                </span>
            </div>
        }


        <div className={classes.Buttons}>
            {
                buttons?.map((button, index) => <BigButton className={classes.Button} onClick={e => clickHandle(button, index)} key={index} outlined={index > 0}>
                    {button.text}
                </BigButton>)
            }
        </div>

    </div>
}


export default props => {
    useStyles(classes)
    const { retentionPromptWin } = props
    //神策
    const sensors = useMemo(() => {
        const typeDic = {
            "1": "免邮",
            "2": "未满足免邮",
            "3": "其他",
            "4": "凑单"
        }
        const beforeLeafType = retentionPromptWin?.type ? typeDic?.[retentionPromptWin?.type] : typeDic[3]
        const beforeLeafSensor = {
            resourcepage_title: 'cart',
            resource_type: beforeLeafType == '未满足免邮' ? 23 : beforeLeafType == '凑单' ? 5 : '',
            resource_content: beforeLeafType == '未满足免邮' ? 'shipping_addmore' : beforeLeafType == '凑单' ? 'AddMore' : '',
            resource_position: beforeLeafType == '未满足免邮' ? 2 : beforeLeafType == '凑单' ? 3 : '',
            type: beforeLeafType
        }
        return { ...beforeLeafSensor }
    }, [retentionPromptWin])

    return <React.Fragment>
        <DisplayTransition in={props.show} className={classes.StayAlertContainer}>
            <div>
                <StayAlert {...props} sensors={sensors} />
            </div>
        </DisplayTransition>
        {props.show && <BlackMask onClick={e => props.onClose(sensors)} />}
    </React.Fragment>
}
